import { NgModule } from '@angular/core';
import { ProfilePageComponent } from './profile-page.component';
import { CertemyCommonModule } from 'common/certemy-common.module';
import { RouterModule } from '@angular/router';
import { NumberParamGuard } from '@certemy/common';
import { SideMenuModule } from 'components/side-menu/side-menu.module';
import { ProfileCardModule } from 'components/profile-card/profile-card.module';
import { InstanceCustomFieldsComponent } from 'features/custom-fields/instance/instance-fields/instance-custom-fields.component';
import { InstanceCustomFieldsModule } from 'features/custom-fields';
import { profilePageCustomFieldsResolver } from './profile-page-custom-fields.resolver';
import { ProfileDetailsComponent } from 'features/profile-page/profile-details/profile-details.component';
import {
  PersonalInfoCommunicationService,
  personalInfoResolver,
  PersonalInfoResolverService,
  PersonalInfoService,
} from 'features/personal-info/personal-info.service';
import { PersonalInfoModule } from 'features/personal-info/personal-info.module';
import { CardModule } from '@certemy/ui-components';

@NgModule({
  declarations: [ProfilePageComponent, ProfileDetailsComponent],
  imports: [
    CertemyCommonModule,
    PersonalInfoModule,
    CardModule,
    SideMenuModule,
    ProfileCardModule,
    InstanceCustomFieldsModule,
    RouterModule.forChild([
      {
        path: ':profileId',
        canActivate: [NumberParamGuard],
        component: ProfilePageComponent,
        data: { numberParams: ['profileId'] },
        resolve: {
          profile: personalInfoResolver,
        },
        children: [
          {
            path: 'profile-details',
            component: ProfileDetailsComponent,
          },
          {
            path: 'custom-fields',
            component: InstanceCustomFieldsComponent,
            resolve: { fields: profilePageCustomFieldsResolver },
          },
          {
            path: 'email-notifications',
            loadChildren: () =>
              import('app/features/profile-page/email-notifications-page/email-notifications-page.module').then(
                m => m.EmailNotificationsPageModule,
              ),
          },
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'profile-details',
          },
        ],
      },
    ]),
  ],
  providers: [
    PersonalInfoResolverService,
    PersonalInfoService,
    PersonalInfoCommunicationService,
  ],
  exports: [ProfilePageComponent],
})
export class ProfilePageModule {}
